import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';

import { AppointmentItem, AppointmentsState } from './appointments.types';
const initialState: AppointmentsState = {
  newAppointment: {
    appointmentDescription: '',
    appointmentMethod: 'video',
    appointmentTime: {
      endTime: '',
      startTime: ''
    },
    appointmentTypeId: '',
    careProvider: '',
    displayName: '',
    doctorId: '',
    fileUpload: {
      ifEmpty: '',
      info: undefined,
      required: false,
      title: undefined
    },
    initialDate: '',
    isUrgentCareDisclaimerRequired: false,
    isWeightManagementAppointment: false,
    membershipData: {
      planId: '',
      planPricePoint: null
    },
    mifAnswers: [],
    programIds: [],
    selectedModality: null,
    src: '',
    status: 'pending',
    uploadRequired: false,
    user: {
      email: '',
      firstName: '',
      lastName: '',
      termsAndConditionsAccepted: false,
      timezone: ''
    }
  },
  pastAppointments: [],
  upcomingAppointments: []
};

const appointmentsSlice = createSlice({
  initialState,
  name: 'appointments',
  reducers: {
    clearNewAppointment: (state) => {
      state.newAppointment = initialState.newAppointment;
    },
    setNewAppointment: (
      state,
      action: PayloadAction<Partial<AppointmentsState['newAppointment']>>
    ) => {
      state.newAppointment = { ...state.newAppointment, ...action.payload };
    },
    setNewAppointmentUser: (
      state,
      action: PayloadAction<Partial<AppointmentsState['newAppointment']['user']>>
    ) => {
      state.newAppointment.user = {
        ...state.newAppointment.user,
        ...action.payload
      };
    },
    setPastAppointments: (state, action: PayloadAction<AppointmentItem[]>) => {
      state.pastAppointments = action.payload;
    },
    setUpcomingAppointments: (state, action: PayloadAction<AppointmentItem[]>) => {
      state.upcomingAppointments = action.payload;
    }
  }
});

export const {
  clearNewAppointment,
  setNewAppointment,
  setNewAppointmentUser,
  setPastAppointments,
  setUpcomingAppointments
} = appointmentsSlice.actions;

export const selectAppointments = (state: RootState) => state.appointments;
export const selectNewAppointment = (state: RootState) => state.appointments.newAppointment ?? {};

export default appointmentsSlice.reducer;
